import React from "react";
import styles from "./GenericInput.module.scss";

const GenericInput = ({
  label,
  placeholder,
  type,
  withRightIcon,
  name,
  icon,
  onChange,
  disabled
}) => {
  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>{label}</label>
      <div className={styles.inputContainer}>
        {icon && (
          <div className={styles.imgContainer}>
            <img className={styles.leftIcon} src={icon} />
          </div>
        )}
        <input
          type={type}
          name={name}
          className={styles.input}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
        />
        {withRightIcon && (
          <img className={styles.withRightIcon} src={withRightIcon} />
        )}
      </div>
    </div>
  );
};

export default GenericInput;
